import React, { useEffect } from 'react'; 
import { Link, useNavigate } from 'react-router-dom';
import { FaSearch } from 'react-icons/fa';

const Header = () => {
  const navigate = useNavigate();
  const token = localStorage.getItem('token');

  // Initialize Bootstrap's JavaScript functionality
  useEffect(() => {
    if (typeof window !== 'undefined' && typeof document !== 'undefined') {
      if (!window.bootstrap) {
        const bootstrapJS = document.createElement('script');
        bootstrapJS.src = 'https://cdn.jsdelivr.net/npm/bootstrap@5.1.3/dist/js/bootstrap.bundle.min.js';
        bootstrapJS.integrity = 'sha384-ka7Sk0Gln4gmtz2MlQnikT1wXgYsOg+OMhuP+IlRH9sENBO0LRn5q+8nbTov4+1p';
        bootstrapJS.crossOrigin = 'anonymous';
        document.body.appendChild(bootstrapJS);
      }
    }
  }, []);

  const handleLogout = () => {
    localStorage.removeItem('token');
    navigate('/login');
  };

  return (
    <nav className="navbar navbar-light bg-light shadow-sm">
      <div className="container">
        {/* Logo and brand */}
        <Link className="navbar-brand" to="/">
          <img
            src="https://i.imgur.com/SPB6PMM.png"
            alt="StoreToYou Logo"
            style={{ height: "50px", width: "auto" }}
          />
        </Link>

        {/* Navigation items - always visible */}
        <div className="d-flex flex-column flex-lg-row align-items-start align-items-lg-center w-100">
          {/* Main nav links */}
          <ul className="navbar-nav me-auto d-flex flex-row gap-3 mb-2 mb-lg-0">
            <li className="nav-item">
              <Link className="nav-link px-0 px-lg-2" to="/">Home</Link>
            </li>
            <li className="nav-item">
              <Link className="nav-link px-0 px-lg-2" to="/city/kelowna">Kelowna Stores</Link>
            </li>
            <li className="nav-item">
              <Link className="nav-link px-0 px-lg-2" to="/dashboard">Dashboard</Link>
            </li>
          </ul>

          {/* Right side items */}
          <div className="d-flex ms-auto align-items-center">
            {/* Search icon */}
            <Link to="/home" className="nav-link me-3">
              <FaSearch size={20} />
            </Link>

            {/* Auth links */}
            <div className="d-flex">
              {token ? (
                <button
                  className="nav-link btn btn-link px-0 px-lg-2"
                  style={{ textDecoration: 'none' }}
                  onClick={handleLogout}
                >
                  Logout
                </button>
              ) : (
                <>
                  <Link className="nav-link px-0 px-lg-2 me-3" to="/register">Register</Link>
                  <Link className="nav-link px-0 px-lg-2" to="/login">Login</Link>
                </>
              )}
            </div>
          </div>
        </div>
      </div>
    </nav>
  );
};

export default Header;